import { createRouter, createWebHistory } from "vue-router";
import Loginauto from './../pages/loginauto';
import Login from './../pages/login';
import Master from './../pages/layouts/master';
import Dashboard from './../pages/dashboard';
import Produccionia from './../pages/produccion-ia';
import Solicitudes from './../pages/solicitudes';
import SolicitudesCreate from './../pages/solicitudes-create';
import Cabina from './../pages/cabina';
import Videos from './../pages/videos';
import Banners from './../pages/banners';
import VideosOnDemand from './../pages/videos-on-demand';
import Reportes from './../pages/reportes';
import Logs from './../pages/logs';
import Secuencias from './../pages/secuencias';
import Relojes from './../pages/relojes';
import Eventos from './../pages/eventos';
import Concursos from './../pages/concursos';
import Audios from './../pages/audios';
import Paquetes from './../pages/paquetes';
import Formulas from './../pages/formulas';
import Relojesmusica from './../pages/relojesmusica';
import Tags from './../pages/tags';
import Catalogos from './../pages/catalogos';
import Usuarios from './../pages/usuarios';
import CorreosAdeudos from './../pages/correos-adeudos';
import DeudasPagar from './../pages/deudas-pagar';
import FacturacionPendiente from './../pages/facturacion-pendiente';
import SituacionFinanciera from './../pages/situacion-financiera';
import CuentasAnuales from './../pages/cuentas-anuales';
import IndicadoresAdministracion from './../pages/indicadores-administracion';
import AnalisisGastos from './../pages/analisis-gastos';
import AnalisisFacturas from './../pages/analisis-facturas';
import AnalisisPagos from './../pages/analisis-pagos';
import CategoriasGastos from './../pages/categorias-gastos';
import RegistrarGasto from './../pages/registrar-gasto';
import VerGastos from './../pages/ver-gastos';
import RegistrarFactura from './../pages/registrar-factura';
import CargaMasivaFacturas from './../pages/carga-masiva-facturas';
import RazonesSociales from './../pages/razones-sociales';
import VerFacturas from './../pages/ver-facturas';
import EditarGasto from './../pages/editar-gasto.vue';
import CategoriasMusicales from './../pages/categorias-musicales.vue';
import DispositivosEtiquetas from './../pages/dispositivos-etiquetas.vue';
import DispositivosLogs from './../pages/dispositivos-logs.vue';

// Indicadores > Operaciones
import IndicadoresOpCanales from './../pages/indicadores/operaciones-canales';
import IndicadoresOpContactos from './../pages/indicadores/operaciones-contactos';
import IndicadoresOpKpi from './../pages/indicadores/operaciones-kpi';
import IndicadoresOpAnalitica from './../pages/indicadores/operaciones-analitica';

// Producci\u00f3n con IA
import Spots from './../pages/produccion-ia/spots';
import Clima from './../pages/produccion-ia/clima';
import CanalesEnlaces from './../pages/canales-enlaces';

const routes = [
  { name: "loginAuto", path: "/loginauto/:token", component: Loginauto },
  { name: "login", path: "/login", component: Login },
  {
      name: "master", path: "/", component: Master, redirect: '/login',
      children: [
          { name: "dashboard", path: "/dashboard", component: Dashboard, meta: { title: 'Dashboard' } },
          { name: "produccion-ia", path: "/produccion-ia", component: Produccionia,
            children: [
                { name: "spots", path: "/produccion-ia/spots", component: Spots },
                { name: "clima", path: "/produccion-ia/clima", component: Clima },
            ],
          },
          { name: "solicitudes", path: "/solicitudes", component: Solicitudes },
          { name: "solicitudes-create", path: "/solicitudes-create", component: SolicitudesCreate },
          { name: "cabina", path: "/cabina", component: Cabina },
          { name: "videos", path: "/videos", component: Videos },
          { name: "banners", path: "/banners", component: Banners, meta: { title: 'Banners', permissions: ['visual_content', 'radios', 'admin'] } },
          { name: "videos-on-demand", path: "/videos-on-demand", component: VideosOnDemand },
          { name: "reportes", path: "/reportes", component: Reportes },
          { name: "logs", path: "/logs", component: Logs },
          { name: "secuencias", path: "/secuencias", component: Secuencias },
          { name: "relojes", path: "/relojes", component: Relojes },
          { name: "eventos", path: "/eventos", component: Eventos },
          { name: "concursos", path: "/concursos", component: Concursos },
          { name: "audios", path: "/audios", component: Audios },
          { name: "paquetes", path: "/paquetes", component: Paquetes },
          { name: "formulas", path: "/formulas", component: Formulas },
          { name: "relojesmusica", path: "/relojesmusica", component: Relojesmusica },
          { name: "tags", path: "/tags", component: Tags, meta: { title: 'Tags' } },
          { name: "catalogos", path: "/catalogos", component: Catalogos },
          { name: "usuarios", path: "/usuarios", component: Usuarios, meta: { title: 'Usuarios', permissions: ['users', 'admin'] } },
          { name: "correos-adeudos", path: "/correos-adeudos", component: CorreosAdeudos, meta: { title: 'Correos de adeudos' } },
          { name: "deudas-pagar", path: "/deudas-pagar", component: DeudasPagar, meta: { title: 'Deudas por pagar' } },
          { name: "facturacion-pendiente", path: "/facturacion-pendiente", component: FacturacionPendiente, meta: { title: 'Facturaci\u00f3n pendiente' } },
          { name: "situacion-financiera", path: "/situacion-financiera", component: SituacionFinanciera, meta: { title: 'Situaci\u00f3n financiera' } },
          { name: "cuentas-anuales", path: "/cuentas-anuales", component: CuentasAnuales, meta: { title: 'Cuentas anuales' } },
          { name: "indicadores-administracion", path: "/indicadores-administracion", component: IndicadoresAdministracion, meta: { title: 'Indicadores de administraci\u00f3n' } },
          { name: "analisis-gastos", path: "/analisis-gastos", component: AnalisisGastos, meta: { title: 'An\u00e1lisis de gastos' } },
          { name: "analisis-facturas", path: "/analisis-facturas", component: AnalisisFacturas, meta: { title: 'An\u00e1lisis de facturas' } },
          { name: "analisis-pagos", path: "/analisis-pagos", component: AnalisisPagos, meta: { title: 'An\u00e1lisis de pagos' } },
          { name: "categorias-gastos", path: "/categorias-gastos", component: CategoriasGastos, meta: { title: 'Categor\u00edas de gastos' } },
          { name: "registrar-gasto", path: "/registrar-gasto", component: RegistrarGasto, meta: { title: 'Registrar gasto' } },
          { name: "ver-gastos", path: "/ver-gastos", component: VerGastos, meta: { title: 'Ver gastos' } },
          { name: "registrar-factura", path: "/registrar-factura", component: RegistrarFactura, meta: { title: 'Registrar factura' } },
          { name: "carga-masiva-facturas", path: "/carga-masiva-facturas", component: CargaMasivaFacturas, meta: { title: 'Carga masiva de facturas' } },
          { name: "razones-sociales", path: "/razones-sociales", component: RazonesSociales, meta: { title: 'Razones sociales' } },
          { name: "ver-facturas", path: "/ver-facturas", component: VerFacturas, meta: { title: 'Ver facturas' } },
          { name: "editar-gasto", path: "/editar-gasto/:id", component: EditarGasto, meta: { title: 'Editar gasto' } },
          { name: "indicadores-op-canales", path: "/indicadores/operaciones/canales", component: IndicadoresOpCanales, meta: { title: 'Metas por canal' } },
          { name: "indicadores-op-llamadas-minutas", path: "/indicadores/operaciones/llamadas-minutas", component: IndicadoresOpContactos, meta: { title: 'Llamadas y Minutas' } },
          { name: "indicadores-op-kpi", path: "/indicadores/operaciones/kpi", component: IndicadoresOpKpi, meta: { title: 'KPI Operaciones' } },
          { name: "indicadores-op-analitica", path: "/indicadores/operaciones/analitica", component: IndicadoresOpAnalitica, meta: { title: 'Anal\u00edtica KPI', requiresAdmin: true } },
          { name: "canales-enlaces", path: "/canales-enlaces", component: CanalesEnlaces, meta: { title: 'Canales y enlaces' } },
          { path: '/playlists-imagenes', redirect: '/categorias-musicales' },
          { name: "categorias-musicales", path: "/categorias-musicales", component: CategoriasMusicales, meta: { title: 'Categor\u00edas Musicales' } },
          { name: "dispositivos-etiquetas", path: "/dispositivos-etiquetas", component: DispositivosEtiquetas, meta: { title: 'Etiquetas de dispositivos' } },
          { name: "dispositivos-logs", path: "/dispositivos-logs", component: DispositivosLogs, meta: { title: 'Reg. Dispositivos' } },
      ]
  },
  { path: '/:pathMatch(.*)*', name: 'not-found', component: () => import('@/pages/pagina-no-encontrada.vue'),
    beforeEnter: (_to, _from, next) => {
      if (!localStorage.getItem('token')) { window.location.href = 'https://panel.vybroo.net'; return; }
      next();
    },
  },
];

const router = createRouter({ history: createWebHistory(), base: '/', routes });

router.beforeEach((to, _from, next) => {
  let perms = [];
  try {
    const cd = JSON.parse(localStorage.getItem('clientData') || '{}');
    perms = Array.isArray(cd.permissions) ? cd.permissions : [];
  } catch {
    if (to.meta.requiresAdmin || (to.meta.permissions && to.meta.permissions.length)) {
      next({ name: 'login' });
      return;
    }
  }

  if (to.meta.requiresAdmin && !perms.includes('admin')) {
    next({ name: 'dashboard' });
    return;
  }

  const required = Array.isArray(to.meta.permissions) ? to.meta.permissions : [];
  if (required.length) {
    const isWildcard = perms.includes('admin');
    const allowed = isWildcard || required.some((permission) => perms.includes(permission));
    if (!allowed) {
      next({ name: 'dashboard' });
      return;
    }
  }

  next();
});

export default router;
